if (!window.customElements.get('popup-dialog')) {
  class PopupDialog extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('button');
      this.dialog = this.querySelector('.popup__wrap');
      this.closeButton = this.querySelector('.popup__close');
      this.overlay = this.querySelector('.popup__overlay');
      this.modal = this.querySelector('.popup');
      this.focusableElements = [];
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.scrollLock = null;
      this.scrollPosition = 0;
    }
  
    connectedCallback() {
      if (this.trigger && this.dialog) {
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.setAttribute('aria-controls', this.dialog.id);
        this.dialog.setAttribute('role', 'dialog');
        this.dialog.setAttribute('aria-modal', 'true');
        this.dialog.setAttribute('aria-hidden', 'true');
        this.closeButton?.setAttribute('aria-label', 'Close dialog');
        
        // Move dialog to end of body (if not already there)
        if (this.dialog.parentElement !== document.body) {
          document.body.appendChild(this.dialog);
        }
        
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.open()
        });
        this.closeButton?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());
        if(this.dialog.querySelector('[data-a11y-dialog-hide]')){
          this.dialog.querySelectorAll('[data-a11y-dialog-hide]').forEach(button => button.addEventListener('click', () => this.close()));
        }
        this.scrollLock = document.querySelector('scroll-lock');
      }
    }
  
    open() {
      this.dialog.classList.add('active');
      this.overlay.classList.add('active');
      setTimeout(() => {
        this.modal.classList.add('active');
      }, 150);
      this.dialog.setAttribute('aria-hidden', 'false');
      this.focusableElements = Array.from(
        this.dialog.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      );
      if (this.closeButton) {
        this.closeButton.focus();
      }
  
      if(this.scrollLock){
        this.scrollLock.lock()
      }
  
      document.addEventListener('keydown', this.handleKeyDown);
    }
  
    close() {
      this.dialog.classList.remove('active');
      this.overlay.classList.remove('active');
      this.modal.classList.remove('active');
      this.dialog.setAttribute('aria-hidden', 'true');
      this.trigger.focus();
  
      document.removeEventListener('keydown', this.handleKeyDown);
  
      setTimeout(() => {
        document.querySelector("html").style.scrollBehavior = "auto";
        // window.scrollTo(0, this.scrollPosition);
      }, 10);    
    
      if(this.scrollLock){
        this.scrollLock.unlock()
      }
      
      // if(this.id === "collection-filters-modal"){
      //   const mainElement = document.getElementById("main");
      //   const elementPosition = mainElement.getBoundingClientRect().top + window.pageYOffset;
  
      //   window.scrollTo({
      //     top: elementPosition,
      //     behavior: 'smooth'
      //   });
      // }
  
    }
  
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.close();
      } else if (event.key === 'Tab') {
        const first = this.focusableElements[0];
        const last = this.focusableElements[this.focusableElements.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  }
  
  customElements.define('popup-dialog', PopupDialog);
}
